import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
    return `/draft-people`
};


function api() {
    return {
        getList: (data: RequestData) => {
            const {params = {}} = data;
            return HttpRequest.get(getUrl(), {
                params: params
            });
        },
        update: (data: RequestData) => {
            const method = "patch";
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest[method](url, data.payload, {});
        }
    };
}

export default api();
